var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.176 14.235a1.858 1.858 0 00-1.882 1.883c0 1.059.77 1.882 1.882 1.882a1.892 1.892 0 001.883-1.882 1.891 1.891 0 00-1.883-1.883zM11.123 2H8.119A4.092 4.092 0 004 6.118c0 .764.647 1.411 1.412 1.411.764 0 1.412-.647 1.412-1.411 0-.706.535-1.294 1.24-1.294h3.007c.758 0 1.4.588 1.4 1.294 0 .47-.236.83-.648 1.064L8.471 9.235a1.45 1.45 0 00-.706 1.236v.94c0 .766.647 1.412 1.411 1.412.765 0 1.412-.646 1.412-1.411v-.118l2.653-1.647c1.236-.765 2-2.118 2-3.53C15.294 3.825 13.471 2 11.124 2z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default ForwardRef;